/**
 *@ngdoc directive
 *@name cbl.finanza.mf.directive:finanzaGestioneOrdine
 *@restrict E
 *@scope
 *@description Componente utilizzato per l'inserimento dei parametri riferiti ad un ordine
 *@param {String} gestioneRichiestaState - Nome dello stato di gestione della richiesta
 */
(function () {
  'use strict';
  var GestioneOrdineCtrl = function (
    $http,
    $q,
    $scope,
    $state,
    $stateParams,
    $window,
    $location,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    messaggiSrvc,
    userSrvc,
    brioSrvc,
    deskSrvc
  ) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.CONSTANTS = CONSTANTS;
    this.$window = $window;
    this.$location = $location;
    this.messaggiFctr = messaggiFctr;
    this.messaggiSrvc = messaggiSrvc;
    this.userSrvc = userSrvc;
    this.brioSrvc = brioSrvc;
    $scope.msg = labelSrvc.getLabel;
    this.deskSrvc = deskSrvc;

    this.ordine = {};
    this.dossier = {};
    this.saldoPortafoglio = {};
    this.dettaglioStrumento = undefined;
    this.tipoOrdine = undefined;
    this.listaContratti = [];
    this.contratto = {};
    this.parametriAggiuntivi = undefined;
    this.profiloCliente = {};
    this.profiloAdeguatezza = {};
    this.mostraParametriAggiuntivi = true;
    this.showFinancialTool = false;
    this.spinner = {
      dettaglioOrdine: false,
      parametriAggiuntivi: false
    };
    this.datepicker = {
      isOpen: false,
      dateOptions: {
        formatDay: 'dd',
        formatMonth: 'MM',
        formatYear: 'yyyy',
        startingDay: 1
      }
    };
    this.regexTestoNota = new RegExp(/^[a-zA-Z \u00E0-\u00FC'0-9,.;:]+$/i);
    this.messaggiFctr.chiudiLoaderBrio();
    this.mostraParametriBloccati = false;
    this.isFromGestioneProposta = false;
    
    this.listaErroriForzabili=null;

    var self = this;

    /**
     * Abilitazioni
     */
    this.userSrvc.abilitazioniPronte.then(function (value) {
      if (value) {
        self.mostraParametriBloccati = self.userSrvc.abilitazioni.some(
          function (abilitazione) {
            return (
              abilitazione.codice.toLowerCase() ===
              self.CONSTANTS.ABILITAZIONI.VISUALIZZA_PARAMETRI_BLOCCATI.toLowerCase()
            );
          }
        );
      }
    });

    /*
     * -------------------------------------
     * START METODI PROMISE PER SERVIZI REST
     * -------------------------------------
     */

    /**
     * @ngdoc method
     * @name promiseCustomerData
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Effettua la chiamata per ricevere il customerdata
     * @return {Promise} - Ritorna una promise contenente il customerdata
     */
    this.promiseCustomerData = function () {
      return self.$http({
        method: 'GET',
        url: CONSTANTS.REST_CUSTOMER + CONSTANTS.REST.CUSTOMER_DOSSIER,
        params: {
          rapporto: self.$stateParams.finCodiceRapporto
        }
      });
    };

    /**
     * @ngdoc method
     * @name promiseDettaglioOrdine
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Effettua una chiamata http per ricevere il dettaglio di un ordine
     * @return {Promise} - Ritorna una promise contenente il dettaglio di un ordine
     */
    this.promiseDettaglioOrdine = function () {
      return self.$http({
        method: 'GET',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.RICHIESTA +
          self.$stateParams.finIdOrdine
      });
    };

    /**
     * @ngdoc method
     * @name promiseDettaglioStrumento
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Effettua la chiamata GET per ricevere il dettaglio dello strumento
     * @param {String} [codiceStrumento] - Parametro opzionale passato esclusivamente quando si viene richiamati dalla funzione financialToolResult
     * @return {Promise} - Ritorna una promise conentente i dati del dettaglio dello strumento
     */
    this.promiseDettaglioStrumento = function (codiceStrumento) {
      var url = CONSTANTS.REST_ROOT + CONSTANTS.REST.STRUMENTO;
      url += codiceStrumento
        ? codiceStrumento
        : self.$stateParams.finCodiceStrumento;
      return self.$http({
        method: 'GET',
        url: url
      });
    };

    /**
     * @ngdoc method
     * @name promiseSaldoPortafoglio
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Effettua la chiamata POST per ricevere il saldo portafoglio
     * @return {Promise} - Ritorna una promise contenente i dati del saldo portafoglio
     */
    this.promiseSaldoPortafoglio = function () {
      return self.$http({
        method: 'GET',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.STRUMENTO +
          self.$stateParams.finCodiceRapporto +
          '/saldi'
      });
    };

    /**
     * @ngdoc method
     * @name promiseTipoOrdineFondo
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Ritorna la lista dei tipo ordine per i fondi
     * @return {Promise} - Ritorna una promise contenente la lista dei tipi di ordine per i fondo
     */
    this.promiseTipoOrdineFondo = function () {
      return self.$http({
        method: 'GET',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.PARAMETRI +
          'fondo/' +
          self.ordine.strumento
      });
    };

    /**
     * @ngdoc method
     * @name promiseGetPresentatoreFondo
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Ritorna i parametri aggiuntivi per il tipo fondo
     * @return {Promise} - Ritorna una promise contenente i parametri aggiuntivi dello strumento di tipo fondo
     */
    this.promiseGetPresentatoreFondo = function () {
      return self.$http({
        method: 'GET',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.PARAMETRI +
          'presentatoreFondo/' +
          self.$stateParams.finCodiceRapporto +
          '/' +
          self.ordine.strumento +
          '/' +
          self.ordine.segno
      });
    };

    /**
     * @ngdoc method
     * @name promiseParametriAggiuntiviFondo
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Ritorna i parametri aggiuntivi per i fondo
     */
    this.promiseParametriAggiuntiviFondo = function () {
      return self.$http({
        method: 'PUT',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.PARAMETRI +
          'fondo/' +
          self.$stateParams.finCodiceRapporto,
        data: {
          strumento: self.ordine.strumento,
          codiceOrdine: self.tipoOrdine.codiceOperazione,
          contratto: self.contratto ? self.contratto.contratto : undefined,
          parametri: self.parametriAggiuntivi,
          quantita: self.ordine.quantita,
          ctvPrevisto: self.ordine.ctvPrevisto
        }
      });
    };

    /**
     * @ngdoc method
     * @name promiseParametriAggiuntiviNonFondo
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Ritorna tutti i dati compresi i parametri aggiuntivi per i non fondi
     */
    this.promiseParametriAggiuntiviNonFondo = function () {
      return self.$http({
        method: 'GET',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.PARAMETRI +
          'nonFondo/' +
          self.$stateParams.finCodiceRapporto +
          '/' +
          self.ordine.strumento +
          '/' +
          self.ordine.segno
      });
    };

    /**
     * @ngdoc method
     * @name promiseProfiloCliente
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Effettua la chiamata rest per il profilo cliente
     * @return {Promise} - Ritorna una promise contenente il profilo del cliente
     */
    this.promiseProfiloCliente = function () {
      return self.$http({
        method: 'GET',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.STRUMENTO +
          'profiloCliente/' +
          self.dossier.ndgIntestatario,
        params: {
          idDossier: self.$stateParams.finCodiceRapporto
        }
      });
    };

    /**
     * @ngdoc method
     * @name promiseProfiloAdeguatezza
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Effettua la chiamata rest per la verifica dell'adeguatezza
     * @return {Promise} - Ritorna una promise contenente la verifica dell'adeguatezza
     */
    this.promiseProfiloAdeguatezza = function () {
      return self.$http({
        method: 'GET',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.STRUMENTO +
          'profiloAdeguatezza/' +
          self.getCodiceStrumento()
      });
    };

    /**
     * @ngdoc method
     * @name promiseInserisciRichiesta
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Inserisce una nuova richiesta
     * @return {Promise} - Ritorna una promise contenente i dati della nuova richiesta
     */
    this.promiseInserisciRichiesta = function () {
      return self.$http({
        method: 'POST',
        url: CONSTANTS.REST_ROOT + CONSTANTS.REST.RICHIESTA + 'richiesta',
        data: {
          codiceDossierTitoli: self.$stateParams.finCodiceRapporto,
          intestatario: {
            //						intestazione: 'FRANCESCO ABBRUZZESE',
            //						formaCostitutiva: 'PRV',
            //						ndg: '354823'
            intestazione: self.posizione.intestazione,
            formaCostitutiva: self.posizione.naturaGiuridicaIntestatario,
            ndg: self.posizione.ndgIntestatario
          },
          idRaccomandazione: self.$stateParams.finIdRaccomandazione || null
        }
      });
    };

    /**
     * @ngdoc method
     * @name promiseContratti
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Chiama la lista dei contratti
     * @return {Promise} - Ritorna una promise contenente la lista dei contratti
     */
    this.promiseContratti = function () {
      var url = CONSTANTS.REST_ROOT + CONSTANTS.REST.STRUMENTO + 'contratti';
      if (self.ordine.segno === self.CONSTANTS.OPERAZIONI.RIMODULAZIONE_PIANO) {
        url = CONSTANTS.REST_ROOT + CONSTANTS.REST.STRUMENTO + 'piani';
      }
      return self.$http({
        method: 'PUT',
        url: url,
        data: {
          dossier: self.$stateParams.finCodiceRapporto,
          prodotto: self.ordine.strumento.trim(),
          ndgSottoscrittore: self.ordine.intestatario
            ? self.ordine.intestatario
            : 0
        }
      });
    };

    /**
     * @ngdoc method
     * @name promiseVerificaNonFondo
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Effettua la chiamata rest per la verifica dei parametri aggiuntivi per non fondo
     * @return {Promise} - Ritorna una promise contenente il risultato della chiamata
     */
    this.promiseVerificaNonFondo = function () {
      var ordine = {
        idOrdine: self.$stateParams.finIdOrdine,
        idRichiesta: self.$stateParams.finIdRichiesta,
        idProposta: self.ordine.idProposta,
        strumento: self.ordine.strumento.trim(),
        quantita: self.ordine.quantita,
        ctvPrevisto: self.ordine.ctvPrevisto,
        intestatario: self.ordine.intestatario,
        nota: self.ordine.nota,
        prezzo: self.ordine.prezzo,
        presentatore: self.ordine.presentatore,
        segno: self.ordine.segno,
        dataScadenza:
          new Date(self.ordine.dataScadenza).getTime() + 1000 * 60 * 60 * 4,
        mercato: self.ordine.mercato,
        divisaISO: self.ordine.divisaISO,
        codiceOrdine: self.ordine.codiceOrdine
      };
      return self.$http({
        method: 'PUT',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.RICHIESTA +
          'verificaNonFondo/' +
          self.$stateParams.finCodiceRapporto,
        data: ordine
      });
    };

    /**
     * @ngdoc method
     * @name promiseVerificaFondo
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Effettua la chiamata rest per la verifica dei parametri aggiuntivi per fondo
     * @return {Promise} - Ritorna una promise contenente il risultato della chiamata
     */
    this.promiseVerificaFondo = function () {
      var ordine = {
        strumento: self.ordine.strumento.trim(),
        intestatario: self.ordine.intestatario,
        presentatore: self.ordine.presentatore,
        codiceOrdine: self.ordine.codiceOrdine,
        quantita: self.ordine.quantita,
        ctvPrevisto: self.ordine.ctvPrevisto,
        contratto: self.contratto.contratto,
        prgContratto: self.contratto.id,
        nota: self.ordine.nota,
        parametri: self.parametriAggiuntivi
      };
      return self.$http({
        method: 'PUT',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.RICHIESTA +
          'verificaFondo/' +
          self.$stateParams.finCodiceRapporto,
        data: ordine
      });
    };

    this.isFON_POG = function () {
      return (
        !!self.dettaglioStrumento &&
        !!self.dettaglioStrumento.categoriaStrumento &&
        (self.dettaglioStrumento.categoriaStrumento.codice.trim() === 'FON' ||
          self.dettaglioStrumento.categoriaStrumento.codice.trim() === 'POG')
      );
    };

    /**
     * @ngdoc method
     * @name promiseInserisciOrdine
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Inserisce un nuovo ordine
     * @return {Promise} - Ritorna una promise contenente il risultato della chiamata
     */
    this.promiseInserisciOrdine = function (ordineToSave) {
      var url = CONSTANTS.REST_ROOT + CONSTANTS.REST.RICHIESTA;
      if (!self.isFON_POG()) {
        url = url + 'ordineNonFondo/';
      } else {
        url = url + 'ordineFondo/';
      }
      url = url + self.$stateParams.finCodiceRapporto;
      return self.$http({
        method: 'POST',
        url: url,
        data: ordineToSave
      });
    };

    /**
     * @ngdoc method
     * @name promiseModificaOrdine
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Modifica un ordine
     * @return {Promise} - Ritorna una promise contenente il risultato della chiamata
     */
    this.promiseModificaOrdine = function (ordineToUpdate) {
      var url = CONSTANTS.REST_ROOT + CONSTANTS.REST.RICHIESTA;
      if (!self.isFON_POG()) {
        url = url + 'modificaOrdineNonFondo/';
      } else {
        url = url + 'modificaOrdineFondo/';
      }
      url = url + self.$stateParams.finCodiceRapporto;
      return self.$http({
        method: 'PUT',
        url: url,
        data: ordineToUpdate
      });
    };

    /*
     * -----------------------------------
     * END METODI PROMISE PER SERVIZI REST
     * -----------------------------------
     */

    /*
     * -----------------------
     * START METODI CONTROLLER
     * -----------------------
     */

    /**
     * @ngdoc method
     * @name recuperaDettaglioOrdine
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
     * @description Ritorna true se il testo della nota rispetta il pattern
     */
    this.checkRegexNota = function (testo) {
      return self.regexTestoNota.test(testo);
    };

    /**
     * @ngdoc methos
     * @name recuperaDettaglioOrdine
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Recupera il dettaglio di un ordine
     */
    this.recuperaDettaglioOrdine = function () {
      self.promiseDettaglioOrdine().then(
        function (response) {
          if (self.messaggiFctr.processaResponse(response)) {
            self.ordine = {};
            self.spinner.dettaglioOrdine = false;
            return;
          }
          self.ordine = response.data.result;
          //				Se ci sono i parametri allora siamo in un fondo
          if (self.ordine.parametri) {
            self.parametriAggiuntivi = self.ordine.parametri;
            self.parametriAggiuntivi.forEach(function (parametro) {
              parametro.codice = parametro.codice.trim();
              parametro.descrizione = parametro.descrizione.trim();
              if (parametro.scelte) {
                parametro.scelte.forEach(function (scelta) {
                  scelta.descrizione = scelta.descrizione.trim();
                  scelta.valore = scelta.valore.trim();
                });
              }
            });
          }
          delete self.ordine.parametri;
          self.recuperaProfiloCliente();
          self.recuperaProfiloAdeguatezza();
          self.dettaglioStrumentoFinanziario();
        },
        function (reason) {
          self.messaggiFctr.processaResponse(reason);
          self.spinner.dettaglioOrdine = false;
        }
      );
    };

    /**
     * @ngdoc method
     * @name recuperaSaldoPortafoglio
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Recupera il saldo portafoglio
     * @return {Array} - Lista dei saldi portafoglio
     */
    this.recuperaSaldoPortafoglio = function () {
      self.promiseSaldoPortafoglio().then(
        function (response) {
          if (self.messaggiFctr.processaResponse(response)) {
            self.saldoPortafoglio = {};
            self.spinner.dettaglioOrdine = false;
            return;
          }
          if (response.data && response.data.result) {
            //					Creo un nuovo array che contiene soltanto gli strumenti
            //    				con lo stesso codice selezionato dal saldo portafoglio
            var saldi = response.data.result.filter(function (saldo) {
              return (
                saldo.strumento.codice.trim() ===
                self.$stateParams.finCodiceStrumento
              );
            });
            //					Se la length è maggiore di 1 allora cerco il saldo con ndg ricevuto tramite params
            if (saldi.length > 1) {
              saldi.forEach(function (saldo) {
                if (
                  saldo.ndgIntestatario &&
                  saldo.ndgIntestatario.toString() ===
                    self.$stateParams.finIntestatarioStrumento
                ) {
                  self.saldoPortafoglio = saldo;
                  // 			Si può presentare anche il caso che ci siano più saldi per un certo strumento, dipende se l'ndg è cointestato o mono.
                  //			Se il saldo dello strumento si riferisce ad un ndg cointestato l'ndgIntestatario arriverà nullo (e quindi verrà passato
                  //			nullo anche negli stateParams). Quindi se $stateParams.finIntestatarioStrumento è nullo seleziono il saldo con ndgIntestatario nullo.
                } else if (
                  !saldo.ndgIntestatario &&
                  !self.$stateParams.finIntestatarioStrumento
                ) {
                  self.saldoPortafoglio = saldo;
                }
              });
            } else {
              //						Prendo l'unico saldo rimasto
              self.saldoPortafoglio = saldi[0];
            }
            //					Chiamo il recupero del dettaglio strumento
          } else {
            self.spinner.saldoPortafoglio = false;
          }
          self.dettaglioStrumentoFinanziario();
        },
        function (reason) {
          self.spinner.saldoPortafoglio = false;
          self.messaggiFctr.processaResponse(reason);
        }
      );
    };

    /**
     * @ngdoc method
     * @name recuperaStrumentoFinanziario
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Funzione richiamata al click su una riga dello strumento finanziario.
     * Tale funzione viene richiamata soltanto durante la creazione di un nuovo ordine
     * @param {Object} - Strumento finanziario ricercato tramite il widget
     */
    this.ricercaStrumentoFinanziario = function (callbackStrumentoFinanziario) {
      self.spinner.dettaglioOrdine = true;
      //    		Ricreo un nuovo ordine quando cerco un nuovo strumento
      self.ordine = {
        segno: $scope.msg('gestione.proposta.a')
      };
      self.parametriAggiuntivi = undefined;
      self.tipoOrdine = undefined;
      self.dettaglioStrumentoFinanziario(
        callbackStrumentoFinanziario.codice.trim()
      );
    };

    /**
     * @ngdoc method
     * @name dettaglioStrumentoFinanziario
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Gestisce la promise del dettaglio strumento finanziario
     */
    this.dettaglioStrumentoFinanziario = function (codiceStrumentoFinanziario) {
      self.promiseDettaglioStrumento(codiceStrumentoFinanziario).then(
        function (response) {
          if (self.messaggiFctr.processaResponse(response)) {
            self.dettaglioStrumento = {};
            self.spinner.dettaglioOrdine = false;
            return;
          }
          self.dettaglioStrumento = response.data.result;
          self.recuperaDatiStrumentoFinanziario();
        },
        function (reason) {
          self.messaggiFctr.processaResponse(reason);
          self.spinner.dettaglioOrdine = false;
        }
      );
    };

    /**
     * @ngdoc method
     * @name recuperDatiStrumentoFinanziario
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Imposta i valori predefiniti per l'ordine in base a creazione/modifica
     */
    this.recuperaDatiStrumentoFinanziario = function () {
      //    		Se sono in modifica effettuo soltanto i trim dei dati (stringhe) ricevuti
      if (self.$stateParams.finIdOrdine) {
        self.ordine.strumento = self.ordine.strumento.trim();
      } else {
        // Sono in creazione quindi recupero altri valori dal dettaglioStrumento
        self.ordine.strumento = self.dettaglioStrumento.codice.trim();

        var divisore = self.calcolaDivisoreQuantita(
          self.dettaglioStrumento.qtaMinimaTrattabile
        );

        var qta = null;
        if (
          self.isFON_POG() &&
          self.dettaglioStrumento.divisa.trim() !== 'EURO'
        ) {
          qta =
            self.dettaglioStrumento.qtaMinimaTrattabile *
            self.dettaglioStrumento.cambioStorico.prezzo;
        } else {
          qta = self.dettaglioStrumento.qtaMinimaTrattabile;
        }

        self.ordine.quantita = Math.round(qta * divisore) / divisore || 1;

        self.ordine.ctvPrevisto =
          Math.round(
            self.dettaglioStrumento.quotazioneUltimoPrezzoStorico.prezzo *
              self.ordine.quantita *
              100
          ) / 100;
        //            	Se provengo da un saldo portafoglio setto l'intestatario del saldo
        if (self.$stateParams.finCodiceStrumento) {
          self.ordine.intestatario = self.saldoPortafoglio.ndgIntestatario;
        } else {
          //        			Se siamo in un non-fondo e
          //        			lo strumento è nominativo e
          //        			l'intestatario del dossier e solo 1
          //        			allora setto come intestatario dell'ordine l'unico intestatario del dossier
          if (
            !self.isPO &&
            self.dettaglioStrumento.nominativo &&
            self.dossier.intestatari.length === 1
          ) {
            self.ordine.intestatario = self.dossier.intestatari[0].ndg;
          }
        }
      }
      if (self.isFON_POG()) {
        self.getDatiAggiuntiviFondo();
      } else {
        self.getParametriAggiuntiviNonFondo();
      }
    };

    /**
     * @ngdoc method
     * @name  recuperaProfiloCliente
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Recupera il profilo cliente
     */
    this.recuperaProfiloCliente = function(){
      this.promiseProfiloCliente()
      .then(function(response){
        if (self.messaggiFctr.processaResponse(response)) {
          self.profiloCliente = {};
          self.spinner.dettaglioOrdine = false;
          return;
        }
        self.profiloCliente = response.data.result;
      })
    }
    /**
     * @ngdoc method
     * @name  recuperaProfiloAdeguattezza
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Recupera il profilo adeguatezza
     */
    this.recuperaProfiloAdeguatezza = function(){
      this.promiseProfiloAdeguatezza()
      .then(function(response){
        if (self.messaggiFctr.processaResponse(response)) {
          self.profiloAdeguatezza = {};
          self.spinner.dettaglioOrdine = false;
          return;
        }
        self.profiloAdeguatezza = response.data.result;
      })
    }
    /**
     * @ngdoc method
     * @name mappingParametri
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Esegue il mapping dell'array parametri per utilizzarlo con le select
     */
    this.mappingParametriNonFondo = function () {
      self.parametriAggiuntivi.forEach(function (parametro) {
        //    			Effettuo un trim dei valori all'interno di ciascuna scelta
        parametro.scelte.forEach(function (scelta) {
          scelta.valore = scelta.valore.trim();
          //    				Imposto il valore del presentatore a un number
          if (parametro.descrizione === 'PRESENTATORE') {
            scelta.valore = Number(scelta.valore) || '';
          }
        });
        switch (parametro.descrizione.trim()) {
          case 'MERCATO':
            self.parametroMercato = parametro;
            break;
          case 'TIPO ORDINE':
            self.parametroTipoOrdine = parametro;
            break;
          case 'DIVISA REGOLAMENTO':
            self.parametroDivisaRegolamento = parametro;
            break;
          case 'PRESENTATORE':
            self.parametroPresentatore = parametro;
            break;
        }
      });
      self.spinner.dettaglioOrdine = false;
    };

    this.getParametriAggiuntiviFondoAsync = function (
      newTipoOrdine,
      oldTipoOrdine,
      index,
      event
    ) {
      setTimeout(function () {
        self.getParametriAggiuntiviFondo(
          newTipoOrdine,
          oldTipoOrdine,
          index,
          event
        );
      }, 100);
    };

    /**
     * @ngdoc method
     * @name getParametriAggiuntiviFondo
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Riceve ed elabora i parametri aggiuntivi per i fondi
     * @param {boolean} oldTipoOrdine - Vecchio valore del tipoOrdine
     * @param {number} index - Index nell'array parametriAggiuntivi del parametro aggiuntivo modificato
     * @param {event} keyCode - Codice del tasto premuto
     */
    this.getParametriAggiuntiviFondo = function (
      newTipoOrdine,
      oldTipoOrdine,
      index,
      event
    ) {
      if (index >= 0) {
        //    			In caso di evento sull'input di testo
        if (event && event.keyCode !== 13) {
          return;
        }
        var gruppo = self.parametriAggiuntivi[index].gruppo;
        var parametriAggiuntiviTmp = self.parametriAggiuntivi.filter(function (
          parametro
        ) {
          return parametro.gruppo <= gruppo;
        });
        self.parametriAggiuntivi = parametriAggiuntiviTmp;
      }
      //    		Se il tipoOrdine è cambiato e quindi c'è un nuovo valore
      if (newTipoOrdine !== oldTipoOrdine) {
        self.parametriAggiuntivi = [];
        //    			Se la select del contratto non si deve far vedere allora annullo il codice contratto scelto
        if (!self.tipoOrdine.codiceContrattoObbligatorio) {
          self.contratto = {};
        }
      }
      //    		Esco perché la funzione viene richiamata quando la select viene popolata e non ho il tipoOrdine
      if (!self.tipoOrdine) {
        return;
      }
      self.spinner.parametriAggiuntivi = true;
      //    		Imposto il codiceOrdine prelevato dall'oggetto tipoOrdine
      self.ordine.codiceOrdine = self.tipoOrdine.codiceOperazione;
      //    		Se il contratto è obbligatorio e non sto operando con i parametri aggiuntivi allora gestisco il contratto
      if (
        (self.tipoOrdine.codiceContrattoObbligatorio ||
          self.ordine.segno === CONSTANTS.OPERAZIONI.RIMODULAZIONE_PIANO) &&
        isNaN(index)
      ) {
        self.getContratti();
      }
      self
        .promiseParametriAggiuntiviFondo()
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              self.parametriAggiuntivi = [];
              return;
            }
            response.data.result.richiesta.parametri.forEach(function (
              parametro
            ) {
              parametro.codice = parametro.codice.trim();
              parametro.descrizione = parametro.descrizione.trim();
              if (parametro.valore) {
                parametro.valore = parametro.valore.trim();
              }
              if (parametro.scelte) {
                parametro.scelte.forEach(function (scelta) {
                  scelta.descrizione = scelta.descrizione.trim();
                  scelta.valore = scelta.valore.trim();
                });
              }
            });
            self.parametriAggiuntivi = response.data.result.richiesta.parametri;
          },
          function (reason) {
            self.parametriAggiuntivi = [];
            self.messaggiFctr.processaResponse(reason);
          }
        )
        .finally(function () {
          self.spinner.parametriAggiuntivi = false;
        });
    };

    /**
     * @ngdoc method
     * @name getContratti
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Metodo che recupera la lista dei contratti per le proposte di tipo fondo
     */
    this.getContratti = function () {
      self.promiseContratti().then(
        function (response) {
          if (self.messaggiFctr.processaResponse(response)) {
            self.listaContratti = [];
            return;
          }
          //    			Effettuo il trim dei valori su cui dovrò operare
          response.data.result.forEach(function (item) {
            item.contratto = item.contratto.trim();
          });
          self.listaContratti = response.data.result;
          if (self.$stateParams.finIdOrdine) {
            self.listaContratti.forEach(function (contratto) {
              if (
                contratto.contratto === self.ordine.contratto.trim() &&
                contratto.id === self.ordine.prgContratto
              ) {
                self.contratto = contratto;
              }
            });
          }
          self.calcolaOptionsContratti();
        },
        function (reason) {
          self.messaggiFctr.processaResponse(reason);
          self.spinner.parametriAggiuntivi = false;
          self.listaContratti = [];
          self.calcolaOptionsContratti();
        }
      );
    };

    /**
     * @ngdoc method
     * @name getDatiAggiuntiviFondo
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Gestisce le due chiamate al tipoOrdine e alla select del presentatore
     */
    this.getDatiAggiuntiviFondo = function () {
      $q.all({
        tipoOrdine: self.promiseTipoOrdineFondo(),
        presentatore: self.promiseGetPresentatoreFondo()
      }).then(
        function (response) {
          if (
            self.messaggiFctr.processaResponse(response.tipoOrdine) ||
            self.messaggiFctr.processaResponse(response.presentatore)
          ) {
            self.arrayTipoOrdine = [];
            self.spinner.parametriAggiuntivi = false;
            return;
          }
          self.getTipoOrdine(response.tipoOrdine);
          self.getPresentatoreFondi(response.presentatore);
        },
        function (reason) {
          self.messaggiFctr.processaResponse(reason.tipoOrdine);
          self.messaggiFctr.processaResponse(reason.presentatore);
          self.arrayTipoOrdine = [];
          self.spinner.parametriAggiuntivi = false;
        }
      );
    };

    /**
     * @ngdoc method
     * @name getPresentatoreFondi
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Gestisce i dati per il presentatore nei fondi
     */
    this.getPresentatoreFondi = function (response) {
      if (!self.$stateParams.finIdProposta) {
        self.ordine.presentatore = response.data.result.presentatore;
      }
      response.data.result.parametri.forEach(function (parametro) {
        //    			Effettuo un trim dei valori all'interno di ciascuna scelta
        parametro.scelte.forEach(function (scelta) {
          scelta.valore = scelta.valore.trim();
          //    				Imposto il valore del presentatore a un number
          if (parametro.descrizione === 'PRESENTATORE') {
            scelta.valore = Number(scelta.valore) || '';
          }
        });
        switch (parametro.descrizione.trim()) {
          case 'PRESENTATORE':
            self.parametroPresentatore = parametro;
            break;
        }
      });
    };

    /**
     * @ngdoc method
     * @name getCodiceStrumento
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
     * @description Setta il giusto codiceStrumento in base a se siamo in uno switch o meno
     * @return string - Ritorna la stringa del codiceStrumento
     */
    this.getCodiceStrumento = function () {
      var codiceStrumento = '';
      //    		Se siamo in uno switch
      if (self.$stateParams.acqven === $scope.msg('gestione.proposta.s')) {
        self.parametriAggiuntivi.forEach(function (parametro) {
          //    				Se trovo il campo dove viene inserito il fondo su cui switchare
          if (parametro.codice.trim() === 'FNSWIPROD') {
            //    					Prendo il valore dello switch scelto nella select
            codiceStrumento = parametro.valore.trim();
          }
        });
      } else {
        codiceStrumento = self.ordine.strumento;
      }
      return codiceStrumento;
    };

    /**
     * @ngdoc method
     * @name getTipoOrdine
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Gestisce i dati per popolare la select tipo ordine
     */
    this.getTipoOrdine = function (response) {
      if (self.messaggiFctr.processaResponse(response)) {
        self.arrayTipoOrdine = [];
        return;
      }
      if (self.ordine.segno === $scope.msg('gestione.ordine.d')) {
        self.arrayTipoOrdine = response.data.result.filter(function (item) {
          return (
            item.segnoOperazione.trim() === $scope.msg('gestione.ordine.d')
          );
        });
      } else if (self.ordine.segno === $scope.msg('gestione.ordine.a')) {
        self.arrayTipoOrdine = response.data.result.filter(function (item) {
          return (
            item.segnoOperazione.trim() === $scope.msg('gestione.ordine.a')
          );
        });
      } else if (self.ordine.segno === $scope.msg('gestione.ordine.s')) {
        self.arrayTipoOrdine = response.data.result.filter(function (item) {
          return (
            item.segnoOperazione.trim() === $scope.msg('gestione.ordine.s')
          );
        });
      } else if (
        self.ordine.segno === self.CONSTANTS.OPERAZIONI.RIMODULAZIONE_PIANO
      ) {
        self.arrayTipoOrdine = response.data.result.filter(function (item) {
          return (
            item.segnoOperazione.trim() ===
            self.CONSTANTS.OPERAZIONI.RIMODULAZIONE_PIANO
          );
        });
      }
      //    			Effettuo il trim dei valori su cui dovrò operare
      self.arrayTipoOrdine.forEach(function (item) {
        item.codiceOperazione = item.codiceOperazione.trim();
        item.descrizione = item.descrizione.trim();
      });
      //    			Se è presente un idOrdine devo trovare l'oggetto di arrayTipoOrdine che ha come stringa il codiceOperazione
      if (self.$stateParams.finIdOrdine) {
        self.arrayTipoOrdine.forEach(function (tipoOrdine) {
          if (tipoOrdine.codiceOperazione === self.ordine.codiceOrdine) {
            self.tipoOrdine = tipoOrdine;
          }
        });
      }
      self.showFinancialTool = false;
      self.spinner.dettaglioOrdine = false;
      //    		Azzero l'oggetto contratto
      self.contratto = {};
      //    		Chiamo i parametri aggiuntivi per il fondo
      self.getParametriAggiuntiviFondo();
    };

    /**
     * @ngdoc method
     * @name getParametriAggiuntiviNonFondo
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Riceve ed elabora i parametri aggiuntivi per i NON fondi
     */
    this.getParametriAggiuntiviNonFondo = function () {
      self.spinner.parametriAggiuntivi = true;
      self
        .promiseParametriAggiuntiviNonFondo()
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              self.parametriAggiuntivi = [];
              return;
            }
            if (!self.$stateParams.finIdOrdine) {
              self.ordine.dataScadenza = response.data.result.dataScadenza;
              self.ordine.divisaISO = response.data.result.divisaISO
                ? response.data.result.divisaISO.trim()
                : null;
              self.ordine.codiceOrdine = response.data.result.codiceOrdine
                ? response.data.result.codiceOrdine.trim()
                : null;
              self.ordine.mercato = response.data.result.mercato
                ? response.data.result.mercato.trim()
                : null;
              self.ordine.prezzo = response.data.result.prezzo;
              self.ordine.presentatore = response.data.result.presentatore;
              //            		Cambio il presentatore in alcuni casi
              if (self.dossier.intestatari.length > 1 && !self.isFON_POG()) {
                self.ordine.presentatore = self.dossier.intestatari[0].ndg;
              }
            }
            self.parametriAggiuntivi = response.data.result.parametri;
            self.mappingParametriNonFondo();
          },
          function (reason) {
            self.parametriAggiuntivi = [];
            self.messaggiFctr.processaResponse(reason);
          }
        )
        .finally(function () {
          self.spinner.parametriAggiuntivi = false;
          self.showFinancialTool = false;
        });
    };

    /**
     * @ngdoc method
     * @name checkVenditaMassima
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Controllo che non supero la quantita disponibile in fase di vendita
     * @param {Number} quantita - Nuova valore della quantita da settare
     * @return {Number} - Il nuovo valore controllato
     */
    this.checkVenditaMassima = function (quantita) {
      return quantita <= self.saldoPortafoglio.quantita
        ? quantita
        : self.saldoPortafoglio.quantita;
    };

    this.calcolaDivisoreQuantita = function (quantitaMinima) {
      if (!quantitaMinima) {
        return 1;
      }
      var quantitaStr = quantitaMinima.toString();
      var decimali = quantitaStr.split('.');
      var nDecimali = decimali[1] ? decimali[1].length : 0;
      var divisore = Math.pow(10, nDecimali);

      return divisore;
    };

    /**
     * @mgdoc method
     * @name checkRimanenzaQuantita
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Controllo che non rimanga una quantita compresa tra 0 e qtaMinimaTrattabile.
     * Se così fosse ritorno un valore che lascia nel portafoglio una quantita pari a qtaMinimaTrattabile
     * @param {Number} quantita - Nuovo valore della quantita da settare
     * @return {Number} - Il nuovo valore controllato
     */
    this.checkRimamenzaQuantita = function (quantita) {
      var qtaDisp = self.saldoPortafoglio.quantita;
      var qtaMin = self.dettaglioStrumento.qtaMinimaTrattabile;
      return qtaDisp - quantita >= 0 &&
        (qtaDisp - quantita >= qtaMin || qtaDisp - quantita === 0)
        ? quantita
        : qtaDisp - qtaMin;
    };

    /**
     * @ngdoc method
     * @name incrementaQuantita
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Incrementa la quantita di 1 unita tramite il pulsante +
     */
    //    	this.incrementaQuantita = function() {
    ////    		Se il taglioSuccessivo è 0 allora incremento di 1
    //    		var newValue = (Number(self.ordine.quantita) || 0) + (Math.round(self.dettaglioStrumento.taglioSuccessivo) || 1);
    ////    		Se sono in vendita effettuo ulteriori controlli
    //    		if (self.$stateParams.acqven === $scope.msg('gestione.proposta.d')) {
    //    			newValue = self.checkVenditaMassima(newValue);
    //    			newValue = self.checkRimamenzaQuantita(newValue);
    //    		}
    //    		self.ordine.quantita = Math.round(newValue * 1000) / 1000;
    //    		self.ordine.ctvPrevisto = Math.round(self.ordine.quantita * self.dettaglioStrumento.quotazioneUltimoPrezzoStorico.prezzo * 100) / 100;
    //    	};

    /**
     * @ngdoc method
     * @name decrementaQuantita
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Decrementa la quantita di 1 unita tramite il pulsante -
     */
    //    	this.decrementaQuantita = function() {
    ////    		Se il taglio successivo è 0 allora incremento di 1
    //    		var newValue = (Number(self.ordine.quantita) || 0) - (Math.round(self.dettaglioStrumento.taglioSuccessivo) || 1);
    ////    		Se vado sotto la qtaMinimaTrattabile non salvo il valore (di conseguenza non andrò mai in negativo)
    //    		if (newValue < self.dettaglioStrumento.qtaMinimaTrattabile) {
    //    			return;
    //    		}
    //    		self.ordine.quantita = Math.round(newValue * 1000) / 1000;
    //    		self.ordine.ctvPrevisto = Math.round(self.ordine.quantita * self.dettaglioStrumento.quotazioneUltimoPrezzoStorico.prezzo * 100) / 100;
    //    	};

    this.apriMfWeb = function (evt) {
      evt.preventDefault();
      evt.stopPropagation();

      self.spinner.parametriAggiuntivi = true;
      // FIXME: aggiungere servizio calcolo link
      $q.when('https://www.milanofinanza.it/')
        .then(function (url) {
          window.open(url, '_mfWebFrame');
        })
        .finally(function () {
          self.spinner.parametriAggiuntivi = false;
        });
    };

    /**
     * @ngdoc method
     * @name checkQuantitaInserita
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Controlla la quantita e la aggiusta se necessario quando si inserisce il valore a mano
     */
    this.checkQuantitaInserita = function () {
      if (!self.isFON_POG()) {
        //    		Controllo se c'è contenuto
        if (!self.ordine.quantita) {
          self.ordine.quantita = self.dettaglioStrumento.qtaMinimaTrattabile;
        }
        //    		Controllo se viene inserito un valore non numerico
        if (isNaN(self.ordine.quantita)) {
          self.ordine.quantita = self.dettaglioStrumento.qtaMinimaTrattabile;
        }
        //    		Rendo la quantita inserita un multiplo del taglio
        //    		self.ordine.quantita = self.ordine.quantita - Math.round(self.ordine.quantita % (self.dettaglioStrumento.taglioSuccessivo || 1));
        //    		Se viene inserito un valore minore della qtaMinimaTrattabile viene impostato quest'ultimo valore
        if (
          self.ordine.quantita < self.dettaglioStrumento.qtaMinimaTrattabile
        ) {
          self.ordine.quantita = self.dettaglioStrumento.qtaMinimaTrattabile;
        }
        //    		Se siamo in vendita effettuo ulteriori controlli
        if (self.$stateParams.acqven === $scope.msg('gestione.proposta.d')) {
          self.ordine.quantita = self.checkVenditaMassima(self.ordine.quantita);
          self.ordine.quantita = self.checkRimanenzaQuantita(
            self.ordine.quantita
          );
        }

        var divisore = self.calcolaDivisoreQuantita(
          self.dettaglioStrumento.qtaMinimaTrattabile
        );

        self.ordine.quantita =
          Math.round(self.ordine.quantita * divisore) / divisore || 1;
      }

      // Se si sta trattando un fondo, controllo se la valuta dello strumento è diversa da EURO e in caso faccio la conversione dalla valuta in euro
      var prezzo;
      if (
        self.isFON_POG() &&
        self.dettaglioStrumento.divisa.trim() !== 'EURO'
      ) {
        prezzo =
          self.dettaglioStrumento.quotazioneUltimoPrezzoStorico.prezzo /
          self.dettaglioStrumento.cambioStorico.prezzo;
      } else {
        prezzo = self.dettaglioStrumento.quotazioneUltimoPrezzoStorico.prezzo;
      }

      //    		Aggiorno il controvalore e imposto a 2 decimali
      self.ordine.ctvPrevisto =
        Math.round(self.ordine.quantita * prezzo * 100) / 100;
    };

    /**
     * @ngdoc method
     * @name checkControvaloreInserito
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Effettua controlli sul controvalore inserito a mano
     */
    this.checkControvaloreInserito = function () {
      // Se si sta trattando un fondo, controllo se la valuta dello strumento è diversa da EURO e in caso faccio la conversione dalla valuta in euro
      var prezzo;
      if (
        self.isFON_POG() &&
        self.dettaglioStrumento.divisa.trim() !== 'EURO'
      ) {
        prezzo =
          self.dettaglioStrumento.quotazioneUltimoPrezzoStorico.prezzo /
          self.dettaglioStrumento.cambioStorico.prezzo;
      } else {
        prezzo = self.dettaglioStrumento.quotazioneUltimoPrezzoStorico.prezzo;
      }

      //    		Se non è stato inserito niente o 0 calcolo il ctvPrevisto in base alla quantità;
      if (!self.ordine.ctvPrevisto) {
        self.ordine.ctvPrevisto = self.ordine.quantita * prezzo;
      }
      //    		Se non è stato inserito un numero lo rimpiazzo calcolandolo in base alla quantita
      if (isNaN(self.ordine.ctvPrevisto)) {
        self.ordine.ctvPrevisto = self.ordine.quantita * prezzo;
      }
      //    		Imposto a 2 decimali il ctv
      self.ordine.ctvPrevisto = Math.round(self.ordine.ctvPrevisto * 100) / 100;

      var divisore = self.calcolaDivisoreQuantita(
        self.dettaglioStrumento.qtaMinimaTrattabile
      );

      self.ordine.quantita =
        Math.round((self.ordine.ctvPrevisto / prezzo) * divisore) / divisore;

      //    		Aggiusto la quantita in base al controvalore inserito
      //    		self.checkQuantitaInserita();
      if (
        self.dettaglioStrumento.categoriaStrumento.codice.trim() === 'FON' ||
        self.dettaglioStrumento.categoriaStrumento.codice.trim() === 'POG'
      ) {
        self.getParametriAggiuntiviFondo();
      }
    };

    /**
     * @ngdoc method
     * @name incrementaPrezzoLimite
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Incrementa di un'unità' il valore del prezzo limite
     */
    this.incrementaPrezzoLimite = function () {
      if (self.ordine.prezzo >= 0) {
        self.ordine.prezzo += 0.01;
        self.ordine.prezzo = Math.round(self.ordine.prezzo * 10000) / 10000;
      }
    };

    /**
     * @ngdoc method
     * @name decrementaPrezzoLimite
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Decrementa di un'unità' il valore del prezzo limite
     */
    this.decrementaPrezzoLimite = function () {
      if (self.ordine.prezzo >= 0) {
        self.ordine.prezzo -= 0.01;
        self.ordine.prezzo = Math.round(self.ordine.prezzo * 10000) / 10000;
      }
    };

    /**
     * @ngdoc method
     * @name calcolaOptionsContratti
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Crea le options per la select relativa ai contratti. A causa di un errore nel calcolo delle quantità disponibili e della formattazione
     * è necessario aggiungere la proprietà labelOption in modo da poter effettuare il calcolo precisamente anche a seconda della precisone
     * desiderata.
     */
    this.calcolaOptionsContratti = function () {
      self.contrattiOptions = [];
      if (self.ordine.segno === self.CONSTANTS.OPERAZIONI.RIMODULAZIONE_PIANO) {
        self.listaContratti.forEach(function (contratto) {
          contratto.labelOption =
            contratto.contratto +
            ' - Stato ' +
            contratto.statoPiano +
            ' ' +
            contratto.tipoPiano;
        });
      } else {
        self.listaContratti.forEach(function (contratto) {
          // Trovo la precisione massima per la quale effettuare la sottrazione senza errori
          var contr = contratto.saldoContratto.toString().split('.');
          var precisioneSaldoContr = contr[1] ? contr[1].length : 1;
          var impegn = contratto.saldoImpegnato.toString().split('.');
          var precisioneSaldoImp = impegn[1] ? impegn[1].length : 1;
          var precisioneMax =
            Math.max(precisioneSaldoContr, precisioneSaldoImp) + 1;
          var divisore = Math.pow(10, precisioneMax);

          contratto.labelOption =
            contratto.contratto +
            '  - QTA DISP: ' +
            (
              Math.round(
                (contratto.saldoContratto - contratto.saldoImpegnato) * divisore
              ) / divisore
            )
              .toString()
              .replace('.', ',');
        });
      }
    };

    /**
     * @ngdoc method
     * @name changeTabMacro
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Setta il tab attuale
     * @param {Object} tab - L'oggetto tab che deve essere setatto come attuale
     */
    this.changeTabMacro = function (tab) {
      self.currentTabMacro = tab;
    };

    /**
     * @ngdoc method
     * @name getStyleTabMacro
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Riceve la classe appropriata per la colorazione del macro
     * @param {Number} currentTabIndex - L'indice del tab corrente
     * @return {String} - Il nome della classe per settare il colore del macro
     */
    this.getStyleTabMacro = function (currentTabIndex) {
      if (currentTabIndex < self.currentTabMacro.index) {
        return 'progress-pass';
      }
      if (currentTabIndex === self.currentTabMacro.index) {
        return 'progress-current';
      }
      return 'progress-next';
    };

    /**
     * @ngdoc method
     * @name getStyleTabMacroReadOnly
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Riceve la classe appropriata per la colorazione del macro (soltanto per la modalita visualizza)
     * @param {Number} currentTabIndex - L'indice del tab corrente
     * @return {String} - Il nome della classe per settare il colore del macro
     */
    this.getStyleTabMacroReadOnly = function (currentTabIndex) {
      if (currentTabIndex < this.currentTabMacro.index) {
        return 'progress-next-read';
      }

      if (currentTabIndex === this.currentTabMacro.index) {
        return 'progress-current-read';
      }

      return 'progress-next-read';
    };

     /**
     * Per la issue CONSULENZA2017-686 in caso di nuova proposta o nuovo ordine e stata modificata la
     * gestione degli errori, in caso di infMessage e warMessage non vengono più mostrati nel toastr in alto nella pagina ma in una modale
     * Se si  clicca conferma il processo continua altrimenti si rimane nella pagina di inserimento parametri
     * @param {*} defer 
     * @description Apre la modale che mostra gli errori forzabili, premendo conferma si prosegue con il processo di verifica,
     * altrimenti si rimane sulla pagina
     */
     this.gestisciErroriForzabili = function(defer)
    {
      self.spinner.dettaglioOrdine = false;
      $('#erroriForzabiliModal').modal('show');

      document.getElementById('confirm-button')
      .onclick= function(){
          $('#erroriForzabiliModal').modal('hide');
          self.spinner.dettaglioOrdine = true;
          defer.resolve();
      };

      document.getElementById('cancel-button')
      .onclick = function(){
          $('#erroriForzabiliModal').modal('hide');
          self.spinner.dettaglioOrdine = true;
          defer.reject();
      }
    }
    /**
     * 
     * @param {*} messageList 
     * @description recupera la lista degli errori forzabili dalla messageList
    */
     this.recuperaErroriForzabili = function(messageList)
    {
      var tempListaErroriForzabili = [];
      var tempListaErroriWar = null;
      var tempListaErroriInf = null;
            if(!!messageList && messageList.infMessages.length > 0){
              tempListaErroriInf = messageList.infMessages.map(function(error){
                    return error;
                });
            }
            if(!!messageList && messageList.warMessages.length > 0){
                tempListaErroriWar = messageList.warMessages.map(function(error){
                    return error;
                });
            };
            if(!!tempListaErroriWar){
              tempListaErroriWar.forEach(function(err){
                tempListaErroriForzabili.push(err);
              });
            }
            if(!!tempListaErroriInf){
              tempListaErroriInf.forEach(function(err){
                tempListaErroriForzabili.push(err);
              });
            }

            return tempListaErroriForzabili;
    }

    /**
     * @ngdoc method
     * @name promiseParametriAggiuntivi
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Funzione che decide quale verifica richiamare in base a fondo/non-fondo
     * @return {Promise} - Ritorna una promise con valori true o false
     */
    this.verificaParametriAggiuntivi = function () {
      //			Reset eventuali messaggi di Brio
      self.messaggiSrvc.reset();
      var defer = $q.defer();
      if (self.isFON_POG()) {
        self.promiseVerificaFondo().then(
          function (response) {
            if(self.$state.current.name.indexOf('visualizzaordine') > -1){
              if (messaggiFctr.processaResponseErroriForzabili(response)) {
                defer.reject();
              } else {
                defer.resolve();
              }
            }else{
              if (messaggiFctr.processaResponseErroriForzabili(response)) {
                defer.reject();
              } else {
                self.listaErroriForzabili = self.recuperaErroriForzabili(response.data.messageList);
                if(self.listaErroriForzabili.length > 0){
                  self.gestisciErroriForzabili(defer);
                }else{
                  defer.resolve();
                }
              }
            }
          },
          function (reason) {
            messaggiFctr.processaResponse(reason);
            defer.reject();
          }
        );
      } else {
        self.promiseVerificaNonFondo().then(
          function (response) {
            if(self.$state.current.name.indexOf('visualizzaordine') > -1){
              if (messaggiFctr.processaResponseErroriForzabili(response)) {
                defer.reject();
              } else {
                defer.resolve();
              }
            }else{
              if (messaggiFctr.processaResponseErroriForzabili(response)) {
                defer.reject();
              } else {
                self.listaErroriForzabili = self.recuperaErroriForzabili(response.data.messageList);
                if(self.listaErroriForzabili.length > 0){
                  self.gestisciErroriForzabili(defer);
                }else{
                  defer.resolve();
                }
              }
            }
          },
          function (reason) {
            messaggiFctr.processaResponse(reason);
            defer.reject();
          }
        );
      }
      return defer.promise;
    };

    this.proseguiOrdine = function () {
      $q.all({
        profiloCliente: self.promiseProfiloCliente(),
        profiloAdeguatezza: self.promiseProfiloAdeguatezza()
      })
        .then(
          function (response) {
            if (
              self.messaggiFctr.processaResponse(response.profiloCliente) ||
              self.messaggiFctr.processaResponse(response.profiloAdeguatezza)
            ) {
              self.profiloCliente = {};
              self.profiloAdeguatezza = {};
              return;
            }
            self.profiloCliente = response.profiloCliente.data.result;
            self.profiloAdeguatezza = response.profiloAdeguatezza.data.result;
            self.changeTabMacro(
              self.TAB_LIST_MACRO[self.currentTabMacro.index + 1]
            );
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason.profiloCliente);
            self.messaggiFctr.processaResponse(reason.profiloAdeguatezza);
            self.profiloCliente = {};
            self.profiloAdeguatezza = {};
          }
        )
        .finally(function () {
          self.spinner.dettaglioOrdine = false;
        });
    };

    /**
     * @ngdoc method
     * @name verifica
     * @methodOf cbl.finanza.mf.directive:fiannzaGestioneOrdine
     * @description Effettua la verifica dell'ordine e procede allo step successivo
     */
    this.verifica = function () {
      self.spinner.dettaglioOrdine = true;
      self.verificaParametriAggiuntivi().then(self.proseguiOrdine, function () {
        self.spinner.dettaglioOrdine = false;
      });
    };

    this.registra = function () {
      self.spinner.dettaglioOrdine = true;
      self.proseguiOrdine();
    };

    /**
     * @ngdoc method
     * @name checkIdRichiesta
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Verifica la presenza o meno di un idRichiesta nello stateParams.
     * Se non è presente effettua prima un inserimento di una richiesta
     */
    this.checkIdRichiesta = function () {
      self.spinner.dettaglioOrdine = true;
      if (self.$stateParams.finIdRichiesta) {
        self.inserisciOrdine(self.$stateParams.finIdRichiesta);
      } else {
        self.promiseInserisciRichiesta().then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              self.spinner.dettaglioOrdine = false;
              return;
            }
            self.$stateParams.finIdRichiesta = response.data.result.idRichiesta;
            self.inserisciOrdine(response.data.result.idPratica);
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);
            self.spinner.dettaglioOrdine = false;
          }
        );
      }
    };

    /**
     * @ngdoc method
     * @name inserisciOrdine
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Effettua l'inserimento di un ordine
     * @param {Number} idRaccomandazione - Id della richiesta
     */
    this.inserisciOrdine = function (idRichiesta) {
      var ordineToSave = {
        idProposta: self.$stateParams.finIdProposta,
        idRichiesta: idRichiesta,
        strumento: self.ordine.strumento,
        quantita: self.ordine.quantita,
        ctvPrevisto: self.ordine.ctvPrevisto,
        nota: self.ordine.nota,
        prezzo: self.ordine.prezzo,
        segno: self.ordine.segno,
        mercato: self.ordine.mercato,
        divisaISO: self.ordine.divisaISO,
        profiloAdeguatezza: self.profiloCliente.profiloAdeguatezza,
        profiloAppropriatezza: self.profiloCliente.profiloAppropriatezza,
        rischioComplessita: self.profiloAdeguatezza.rischioComplessita,
        rischioEmittente: self.profiloAdeguatezza.rischioEmittente,
        rischioLiquidita: self.profiloAdeguatezza.rischioLiquidita,
        rischioMercato: self.profiloAdeguatezza.rischioMercato,
        contratto: self.contratto.contratto,
        prgContratto: self.contratto.id,
        codiceOrdine: self.ordine.codiceOrdine,
        presentatore: self.ordine.presentatore,
        intestatario: self.ordine.intestatario
      };
      if (!self.isFON_POG()) {
        ordineToSave.dataScadenza =
          new Date(self.ordine.dataScadenza).getTime() + 1000 * 60 * 60 * 4;
        delete ordineToSave.ctvPrevisto;
      } else {
        ordineToSave.parametri = self.parametriAggiuntivi;
      }
      self
        .promiseInserisciOrdine(ordineToSave)
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }
            self.$stateParams.finIdRichiesta = idRichiesta;
            self.$state.go(self.gestioneRichiestaState, self.$stateParams);
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);
          }
        )
        .finally(function () {
          self.spinner.dettaglioOrdine = false;
        });
    };

    /**
     * @ngdoc method
     * @name modificaOrdine
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Effettua la modifica di un ordine
     */
    this.modificaOrdine = function () {
      var ordineToUpdate = {
        idProposta: self.$stateParams.finIdProposta,
        idOrdine: self.ordine.idOrdine,
        idRichiesta: self.ordine.idRichiesta,
        strumento: self.ordine.strumento,
        quantita: self.ordine.quantita,
        ctvPrevisto: self.ordine.ctvPrevisto,
        intestatario: self.ordine.intestatario,
        nota: self.ordine.nota,
        prezzo: self.ordine.prezzo,
        presentatore: self.ordine.presentatore,
        segno: self.ordine.segno,
        dataScadenza:
          new Date(self.ordine.dataScadenza).getTime() + 1000 * 60 * 60 * 4,
        mercato: self.ordine.mercato,
        divisaISO: self.ordine.divisaISO,
        profiloAdeguatezza: self.profiloCliente.profiloAdeguatezza,
        profiloAppropriatezza: self.profiloCliente.profiloAppropriatezza,
        contratto: self.contratto.contratto,
        prgContratto: self.contratto.id,
        rischioComplessita: self.profiloAdeguatezza.rischioComplessita,
        rischioEmittente: self.profiloAdeguatezza.rischioEmittente,
        rischioLiquidita: self.profiloAdeguatezza.rischioLiquidita,
        rischioMercato: self.profiloAdeguatezza.rischioMercato,
        codiceOrdine: self.ordine.codiceOrdine
      };
      if (self.isFON_POG()) {
        ordineToUpdate.parametri = self.parametriAggiuntivi;
      } else {
        delete ordineToUpdate.ctvPrevisto;
      }
      self.promiseModificaOrdine(ordineToUpdate).then(
        function (response) {
          if (self.messaggiFctr.processaResponse(response)) {
            return;
          }
          self.$state.go(self.gestioneRichiestaState, self.$stateParams);
        },
        function (reason) {
          self.messaggiFctr.processaResponse(reason);
        }
      );
    };

    /**
     * @ngdoc method
     * @name avanti
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Procede allo step successivo, possibile soltanto in modalita lettura
     */
    this.avanti = function () {
      self.profiloCliente.profiloAdeguatezza = self.ordine.profiloAdeguatezza;
      self.profiloCliente.profiloAppropriatezza =
        self.ordine.profiloAppropriatezza;
      self.profiloAdeguatezza.rischioComplessita =
        self.ordine.rischioComplessita;
      self.profiloAdeguatezza.rischioEmittente = self.ordine.rischioEmittente;
      self.profiloAdeguatezza.rischioLiquidita = self.ordine.rischioLiquidita;
      self.profiloAdeguatezza.rischioMercato = self.ordine.rischioMercato;
      self.changeTabMacro(self.TAB_LIST_MACRO[self.currentTabMacro.index + 1]);
    };

    /**
     * @ngdoc method
     * @name indietro
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
     * @description Ritorna allo step precedente se sono allo step1 altrimenti allo stato precedente in base ai casi nello switch
     */
    this.indietro = function () {
      if (self.deskSrvc.isDesk) {
        self.deskSrvc.popEntry();
      }
      if (self.currentTabMacro.index > 0) {
        self.changeTabMacro(
          self.TAB_LIST_MACRO[self.currentTabMacro.index - 1]
        );
      } else {
        switch (self.$state.current.name) {
          case 'nuovoordine':
          case 'home.nuovoordine':
            self.$state.go(self.saldoDossierState, self.$stateParams);
            break;
          case 'modificaordine':
          case 'home.modificaordine':
            self.$state.go(self.gestioneRichiestaState, self.$stateParams);
            break;
          case 'visualizzaordine':
          case 'home.visualizzaordine':
            //					Devo utilizzare l'history.back() perché non so se provengo da gestioneRichiesta o visualizzaRichiesta
            self.$window.history.back();
            break;
        }
      }
    };

    /*
     * ---------------------
     * END METODI CONTROLLER
     * ---------------------
     */

    /*
     * ----------------------------
     * START METODI INIT CONTROLLER
     * ----------------------------
     */

    this.checkCasiDaGestire = function () {
      /*
       * Casi da gestire quando entro in gestioneOrdine
       * 1 - Nuovo ordine
       *   Se non ho idOrdine apro ricercaStrumento: ricercaStrumento -> dettaglioStrumento -> parametriAggiuntivi
       * 2 - Nuovo ordine dal saldo portafoglio
       *   Se ho soltanto codiceStrumento chiamo saldoPortafoglio -> dettaglioStrumento -> parametriAggiuntivi
       * 3 - Modifica ordine
       *   Se ho idOrdine e codiceStrumento: dettaglioOrdine -> dettaglioStrumento -> parametriAggiuntivi
       */
      if (
        self.$stateParams.finCodiceStrumento &&
        self.$stateParams.finIdOrdine
      ) {
        // Modifica di un ordine
        self.spinner.dettaglioOrdine = true;
        self.recuperaDettaglioOrdine();
      } else if (
        self.$stateParams.finCodiceStrumento &&
        !self.$stateParams.finIdOrdine
      ) {
        // Nuovo ordine da saldo
        self.spinner.dettaglioOrdine = true;
        //	    		Setto il segno se vengo dal saldo portafoglio
        self.ordine.segno = self.$stateParams.acqven;
        self.recuperaSaldoPortafoglio();
      } else {
        // Nuovo ordine
        self.showFinancialTool = true;
      }
    };

    labelSrvc.labelsPronte.then(function () {
      self.TAB_LIST_MACRO = [
        {
          index: 0,
          url:
            self.CONSTANTS.BASE_ROOT +
            self.CONSTANTS.COMPONENTS_PATH +
            'gestioneOrdine/partials/inserimentoParametri.html',
          title: $scope.msg('step.preparazione.ordine')
        },
        {
          index: 1,
          url:
            self.CONSTANTS.BASE_ROOT +
            self.CONSTANTS.COMPONENTS_PATH +
            'gestioneOrdine/partials/verificaAdeguatezza.html',
          title: $scope.msg('step.verifica.appropriatezza')
        }
      ];
      self.currentTabMacro = self.TAB_LIST_MACRO[0];
    });

    this.$http({
      method: 'GET',
      url:
        CONSTANTS.REST_ROOT +
        CONSTANTS.REST.DOSSIER +
        self.$stateParams.finCodiceRapporto
    }).then(
      function (response) {
        if (self.messaggiFctr.processaResponse(response)) {
          return;
        }
        self.dossier = response.data.result;
        self.checkCasiDaGestire();
      },
      function (reason) {
        self.messaggiFctr.processaResponse(reason);
      }
    );

    // Chiamo il getDossier per inserire le info nel customerdata
    self.promiseCustomerData().then(
      function (response) {
        if (self.messaggiFctr.processaResponse(response)) {
          self.posizione = {};
          return;
        }
        self.posizione = response.data;
      },
      function (reason) {
        self.messaggiFctr.processaResponse(reason);
      }
    );

    /*
     * --------------------------
     * END METODI INIT CONTROLLER
     * --------------------------
     */

    if (self.deskSrvc.isDesk) {
      labelSrvc.labelsPronte.then(function () {
        self.deskSrvc.aggiungiEntry(labelSrvc.getLabel('gestione.ordine'));
      });
    }
  };

  GestioneOrdineCtrl.$inject = [
    '$http',
    '$q',
    '$scope',
    '$state',
    '$stateParams',
    '$window',
    '$location',
    'FIN_CONSTANTS',
    'FinLabelSrvc',
    'FinMessaggiFctr',
    'CblMessageSrvc',
    'FinUserSrvc',
    'FinBrioSrvc',
    'FinDeskSrvc'
  ];

  var TemplateUrl = function (CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'gestioneOrdine/gestioneOrdine.html'
    );
  };
  TemplateUrl.$inject = ['FIN_CONSTANTS'];

  var GestioneOrdineComponent = {
    bindings: {
      gestioneRichiestaState: '@',
      visualizzaRichiestaState: '@',
      saldoDossierState: '@'
    },
    controller: GestioneOrdineCtrl,
    controllerAs: 'gestioneCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.finanza.mf')
    .component('finanzaGestioneOrdine', GestioneOrdineComponent);
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/components/gestioneOrdine/gestioneOrdine.cmpt.js
 ** module id = 20
 ** module chunks = 0 1 2
 **/